import React, {useEffect} from 'react';
import {fetchContestTimes, fetchEvents} from 'modules/actions';
import {useDispatch, useSelector} from 'react-redux';
import { getIsBettingAllowed, getRegionSelector, getTriviaEvents } from 'modules/selectors';
import styled from 'styled-components';
import {CardsRow} from 'pages/landing/cards/styled';
import {UpcomingQuiz} from 'pages/landing/cards/UpcomingQuiz';
import { BetCard } from './cards/BetCard';

const Wrapper = styled.div`
  padding: 36px;
  
  &.hidden {
	padding: 0;
  }
  
  @media screen and (max-width: 1000px){
	padding: 20px;

	&.hidden {
	  padding: 0;
	}
  }
`;

export const Events: React.FC = () => {
	const dispatch = useDispatch();
	const region = useSelector(getRegionSelector);
	const isBettingAllowed = useSelector(getIsBettingAllowed);
	const event = useSelector(getTriviaEvents);

	const className = !event && !isBettingAllowed ? "hidden" : "";


	useEffect(() => {
		dispatch(fetchEvents({region, skipLoginCheck: true}));
		dispatch(fetchContestTimes());
	}, [dispatch, region]);

	return (
		<Wrapper className={className}>
			<CardsRow>
				<BetCard/>
				<UpcomingQuiz/>
			</CardsRow>
		</Wrapper>
	);
}
